import React from "react";
import { Breakdown } from "./Breakdown";
import { Stack } from "@bookingcom/bui-react";
import { Atol, HiddenFees, SIRF, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownOrderController,
  type UnifiedPriceBreakdownOrderControllerProps
} from "./useUnifiedPriceBreakdown.Order.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownOrderProps = UnifiedPriceBreakdownOrderControllerProps;

export function UnifiedPriceBreakdownOrder(props: UnifiedPriceBreakdownOrderProps) {
  const {
    unifiedPriceBreakdown,
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    addedItems,
    routeName,
    expandedByDefault
  } = useUnifiedPriceBreakdownOrderController(props);

  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "Order", routeName });
    return null;
  }

  return (
    <Stack>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        addedItems={addedItems}
        expandedByDefault={expandedByDefault}
        isWithDiscount={isWithDiscount} // flights_web_unified_price_breakdown
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <SIRF />
      <HiddenFees />
    </Stack>
  );
}
